import React, { FC, useEffect } from 'react';
import { useAuthContext } from '../AuthProvider';
import { Loading } from '../../_common';
import { Routes } from '../../../utils';
import './Callback.scss';
import { PermissionEnum } from '../../../types/PermissionEnum';

const Callback: FC = () => {
    const { userManager } = useAuthContext();

    useEffect(() => {
        let cancelled = false;
        userManager
            .signinRedirectCallback()
            .then(user => {
                if (cancelled) return;
                if (user) {
                    const role = user.profile.role;
                    if (
                        role === PermissionEnum.Admin ||
                        role === PermissionEnum.CustomerService ||
                        role === PermissionEnum.Customer
                    ) {
                        window.location.href = `${window.location.origin}${Routes.DASHBOARD.route}`;
                    } else if (role === PermissionEnum.Operation || role === PermissionEnum.Carrier) {
                        window.location.href = `${window.location.origin}${Routes.CARRIERDASHBOARD.route}`;
                    }
                } else {
                    window.location.href = window.location.origin;
                }
            })
            .catch(err => {
                if (cancelled) return;
                console.error('OIDC callback error:', err);
                // No matching state: login started on a different origin than callback (e.g. localhost vs opsportal-dev)
                const origin = window.location.origin;
                const isStateError = err?.message?.toLowerCase().includes('state');
                window.location.replace(`${origin}${isStateError ? '?callback_error=state' : '?callback_error=1'}`);
            });
        return () => {
            cancelled = true;
        };
    }, [userManager]);

    return (
        <span className="Callback-Loading">
            <Loading />
        </span>
    );
};

export default Callback;
